// src/componentes/Sidebar.js
import React from 'react';
import {
  Boxes,
  Building2,
  ClipboardList,
  FileBarChart,
  GraduationCap,
  KeyRound,
  MonitorCog,
  PackageCheck,
  ShieldCheck,
  UsersRound,
} from 'lucide-react';

const Sidebar = ({ onSeleccionar, opcionActiva }) => {
  const opciones = [
    { id: 'gestion-admins', label: 'Administradores', icono: ShieldCheck },
    { id: 'gestion-docentes', label: 'Docentes', icono: GraduationCap },
    { id: 'lista-pedidos', label: 'Pedidos', icono: ClipboardList },
    { id: 'colegios', label: 'Colegios', icono: Building2 },
    { id: 'salas', label: 'Salas', icono: UsersRound },
    { id: 'equipos', label: 'Equipos', icono: MonitorCog },
    { id: 'componentes', label: 'Componentes', icono: Boxes },
    { id: 'solicitudes-repuestos', label: 'Solicitudes Repuestos', icono: PackageCheck },
    { id: 'permisos-tecnicos', label: 'Permisos Técnicos', icono: KeyRound },
    { id: 'informes', label: 'Informes', icono: FileBarChart },
  ];

  return (
    <nav className="admin-nav" aria-label="Navegación del panel">
      <div className="admin-nav-label">Gestión</div>

      <ul className="admin-nav-list">
        {opciones.map((opcion) => {
          const Icono = opcion.icono;

          return (
            <li key={opcion.id} className="admin-nav-item">
              <button
                onClick={() => onSeleccionar(opcion.id)}
                className={`admin-nav-btn ${opcionActiva === opcion.id ? 'active' : ''}`}
              >
                <Icono size={18} />
                <span>{opcion.label}</span>
              </button>
            </li>
          );
        })}
      </ul>
    </nav>
  );
};

export default Sidebar;
